import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v392u5bk7d: FaireBrandEntity = {
  token: "b_v392u5bk7d",
  type: "brand",
  name: "Wallflower Paper & Party",
  avatarUrl:
    "https://cdn.faire.com/fastly/00deeebca91e042e97131bfac27dcab571cf603d39709e41a63f8f5439a73d9c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/148e0243b7b1dcdaef5bbdd154d5942c96c2fc1096ed2229428c8eb6b2d44033.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/00deeebca91e042e97131bfac27dcab571cf603d39709e41a63f8f5439a73d9c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/148e0243b7b1dcdaef5bbdd154d5942c96c2fc1096ed2229428c8eb6b2d44033.jpeg",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 61,
  isTopShop: true,
  isInsider: true,
  description:
    "Wallflower Paper & Party started as a shopfront in 2022 on a quaint historical street in the heart of Philadelphia. We imagined a cozy place to shop that felt whimsical, perfectly messy, and uniquely soft and precious.  Like shopping in a magical fairytale with faux cakes on the walls and painted clouds on the ceiling. \n\nAfter being on the hunt for the perfect cards, we decided to design our own! You'll find our line to be nostalgic to something you can't quite put your finger on, a nod to childhood playfulness and the small wonders all around us. \n\nAs shopkeepers ourselves, we understand the flow of business, customer needs, and the important of restocking. Please reach out if you need help curating a collection, have a suggestion for a new product or if you need shipping asap (we already ship most orders same or next day)- no matter what we would love to hear from you! \n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:19.741Z",
    importedBy: "entity-db-cli",
  },
};
